import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Incarico } from "../models/incarico";
import * as moment from "moment";
import { ResourcefulService } from "./resourcefulService";
import { Comune } from "../models/comune";

@Injectable({
  providedIn: "root",
})
export class IncaricoService extends ResourcefulService<Incarico> {
  constructor(private httpClient: HttpClient, private toast: ToastrService) {
    super(httpClient, Incarico);
  }

  async countPregressiByIncarico(incaricoId: number): Promise<number> {
    // Replicate pagination/search params used by ResourcefulService.getAll
    const desiresPagination = true;
    const requestedPage = 0;
    const objectsPerPage = 1;

    // Default sort matches Incarico model defaults
    const sortedColumn = Incarico.getDefaultSortKey();
    const sortDirection = Incarico.getDefaultSortDirection();

    const params: any = {
      "relations[]": [],
      sortedColumn,
      sortDirection,
      objectsPerPage: "" + Math.max(1, objectsPerPage),
      requestedPage: "" + Math.max(0, requestedPage),
      desiresPagination: "" + desiresPagination,
      search: JSON.stringify({ pregresso: { incarico: incaricoId } }),
    };

    // Clean undefined/NaN/empty but keep 0s
    Object.keys(params).forEach((key) => {
      if (
        params[key] !== 0 &&
        (!params[key] || params[key] == "NaN" || params[key] == undefined)
      ) {
        params[key] = "";
      }
    });

    const url = `${this.baseUrl}/${Incarico.apiUrl}`;
    const resp = await this.httpClient
      .get<{ data: any[]; count?: number }>(url, { params })
      .toPromise();
    return typeof resp?.count === "number"
      ? resp.count
      : resp?.data?.length || 0;
  }

  inserimentoDaPortale(file: File, modalita_parsing): Promise<Incarico> {
    const formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("parser", modalita_parsing);

    return this.httpClient
      .post<Incarico>(
        `${this.baseUrl}/${Incarico.apiUrl}/inserimento_da_portale`,
        formData
      )
      .toPromise();
  }

  ricavaIncarichiDaCitta(citta: Comune) {
    let url = `${this.baseUrl}/${this.modelClass.apiUrl}/coordinate`;
    if (citta != null) url += `/${citta?.id}`;
    console.log(url);
    return this.httpClient.get<any>(url).toPromise();
  }

  public create(model: Incarico): Promise<Incarico> {
    if ((model as any)?.note?.includes("Reincarico")) {
      (model as any).data = moment();
      this.toast.warning("Reincarico rilevato! Data impostata a oggi.");
    }
    return super.create(model);
  }

  annullaParcella(incarico: Incarico) {
    return this._httpClient
      .get(
        `${this.baseUrl}/${this.modelClass.apiUrl}/annulla_parcella/${incarico.id}`
      )
      .toPromise();
  }

  getFilesPublicUrl(incarico: Incarico) {
    return this._httpClient
      .get(`${this.baseUrl}/incarico/${incarico.id}/files/public`)
      .toPromise();
  }

  salvaPeriziaDati(incaricoId: number, data: {}): Promise<Incarico> {
    return this.httpClient
      .post<Incarico>(`${this.baseUrl}/${Incarico.apiUrl}/salva-perizia`, {
        incaricoId,
        data,
      })
      .toPromise();
  }

  salvaPerizia0peDati(incaricoId: number, data: {}): Promise<Incarico> {
    return this.httpClient
      .post<Incarico>(
        `${this.baseUrl}/${Incarico.apiUrl}/salva-perizia-0pe`,
        {
          incaricoId,
          data,
        }
      )
      .toPromise();
  }

  getIncarichiUrgenti(): Promise<Array<Incarico>> {
    return this.httpClient
      .get<Incarico[]>(`${this.baseUrl}/${Incarico.apiUrl}/incarichi-urgenti`)
      .toPromise()
      .then((data) => {
        return data.map((item) => new Incarico().deserialize(item));
      });
  }

  getDataStoreFromIncarico(incaricoId): Promise<any> {
    return this.httpClient
      .get<any>(`${this.baseUrl}/${Incarico.apiUrl}/data-store/${incaricoId}`)
      .toPromise();
  }

  canAccessGenerali(incaricoId: number): Promise<boolean> {
    return this.httpClient
      .get<boolean>(
        `${this.baseUrl}/${Incarico.apiUrl}/access-generali/${incaricoId}`
      )
      .toPromise();
  }
}
